<template>
  <div class="title">
    <p> от <span>{{rangeMin | moneyFormat}}</span>
<!--      <span class="rubl">a</span>-->
    </p>
    <p> до <span>{{rangeMax | moneyFormat}}</span>
<!--      <span class="rubl">a</span>-->
    </p>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  export default {
    name: "rangeBottomLine",
    computed: {
      ...mapState({
        rangeMin: state => state.Deal.MinSumm,
        rangeMax: state => state.Deal.MaxSumm,
      })
    }
  }
</script>

<style scoped>
  .title {display: flex;justify-content: space-between;align-items: center}
  .title {font-size: 3.2vw;}
  @media screen and (min-width: 760px) {
    .title {}
    .title {font-size: 1.1vw}
    .title:first-child {font-size: 1.4vw;}
  }
  @media screen and (min-width: 1140px) {
    .title {font-size: 12px;}
  }
</style>
